import React from 'react'
import ServiceReinvent from '../Components/ServiceReinvent'
import { Helmet } from 'react-helmet-async'

function Capability() {
    return (
        <div>
             <Helmet>
                <title>
                    Technology Capabilities | AI, Cloud & Product Engineering | Mobikode
                </title>

                <meta
                    name="description"
                    content="Explore Mobikode's technology capabilities across AI and automation, cloud engineering, product engineering, quality engineering, enterprise applications, digital workflows, and managed services."
                />

                <meta
                    name="keywords"
                    content="Technology Capabilities, IT Capabilities, Digital Transformation Capabilities, AI Automation Services, Cloud Engineering Services, Product Engineering Services, Quality Engineering Services, Enterprise Application Services, Digital Workflow Services, Managed IT Services, Technology Consulting Services, Software Engineering Services, Enterprise Technology Solutions, Digital Engineering Services"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/capabilities"
                />

                <meta
                    property="og:title"
                    content="Technology Capabilities | AI, Cloud & Product Engineering | Mobikode"
                />

                <meta
                    property="og:description"
                    content="Discover Mobikode's technology capabilities designed to help businesses innovate, modernize, automate operations, build digital products, and achieve long-term transformation."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/capabilities"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/new-service/bg1.png"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Technology Capabilities | AI, Cloud & Product Engineering | Mobikode"
                />

                <meta
                    name="twitter:description"
                    content="Explore Mobikode's capabilities in AI and automation, cloud engineering, product development, quality engineering, enterprise applications, digital workflows, and managed services."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/new-service/bg1.png"
                />
            </Helmet>
            <section className="relative w-full h-[600px] lg:h-[700px] flex items-center bg-[#000814] overflow-hidden">

                {/* 1. Background Image (Absolute) */}
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/new-service/bg1.png"
                        alt="Abstract 3D Background"
                        className="w-full h-full object-cover"
                    />
                    <div style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }} className="absolute inset-0 "></div>
                </div>
                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] lg:px-[80px] flex flex-col items-start justify-center h-full">

                    <div className="mt-16 lg:mt-0">
                        <h1 className="text-white font-[600] text-5xl md:text-[60px] font-sora leading-[1.1] mb-[22px] drop-shadow-xl tracking-wide text-left">
                            Capabilities
                        </h1>

                        <p className="text-[#FFFFFF] text-[14px] md:text-[16px] leading-[24px] font-graphik font-[500] tracking-wider text-left">
                            Technology. Transformation. Trust.
                        </p>

                    </div>

                </div>

            </section>
            <ServiceReinvent />
        </div>
    )
}

export default Capability
